import { render, staticRenderFns } from "./ClientOpportunities.vue?vue&type=template&id=d55f3a08&scoped=true"
import script from "./ClientOpportunities.vue?vue&type=script&lang=js"
export * from "./ClientOpportunities.vue?vue&type=script&lang=js"
import style0 from "./ClientOpportunities.vue?vue&type=style&index=0&id=d55f3a08&prod&scoped=true&lang=css"
import style1 from "./ClientOpportunities.vue?vue&type=style&index=1&id=d55f3a08&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55f3a08",
  null
  
)

export default component.exports